import React from 'react';
import type { GoalsStreakInfo } from '../../types';

interface GoalsStreaksPanelProps {
  streaks: GoalsStreakInfo[];
  onSelectFixture: (fixtureId: number) => void;
}

export function GoalsStreaksPanel({ streaks, onSelectFixture }: GoalsStreaksPanelProps) {
  if (!streaks.length) return null;

  const getStreakConfig = (type: string) => {
    switch (type) {
      case 'btts':
        return { label: 'BTTS', color: '#22c55e', bg: 'rgba(34, 197, 94, 0.12)' };
      case 'scoring':
        return { label: 'Scoring', color: '#3b82f6', bg: 'rgba(59, 130, 246, 0.12)' };
      case 'clean_sheet_breaker':
        return { label: 'Conceding', color: '#f97316', bg: 'rgba(249, 115, 22, 0.12)' };
      case 'high_scoring':
        return { label: 'O2.5', color: '#ef4444', bg: 'rgba(239, 68, 68, 0.12)' };
      default:
        return { label: type, color: '#6b7280', bg: 'rgba(107, 114, 128, 0.12)' };
    }
  };

  return (
    <div className="goals-streaks-panel">
      <div className="goals-streaks-header">
        <span className="goals-streaks-label">🔥 Streaks</span>
        <span className="goals-streaks-count">{streaks.length}</span>
      </div>
      <div className="goals-streaks-scroll">
        {streaks.map((streak) => {
          const config = getStreakConfig(streak.streak_type);
          return (
            <button
              key={streak.id}
              className="goals-streak-chip"
              onClick={() => streak.next_fixture_id && onSelectFixture(streak.next_fixture_id)}
              style={{
                '--chip-color': config.color,
                '--chip-bg': config.bg,
              } as React.CSSProperties}
            >
              {streak.team_logo && (
                <img src={streak.team_logo} alt="" className="goals-streak-logo" />
              )}
              <span className="goals-streak-name">{streak.team_name}</span>
              <span className="goals-streak-badge" style={{ background: config.bg, color: config.color }}>
                {config.label} ×{streak.streak_length}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default GoalsStreaksPanel;
